﻿import idiDirectives from "./directives/directives.module";
import idiServices from "./services/services.module";
import idiConstants from "./constants/constants.module";

export default angular.module('core', ['ui.router', idiDirectives, idiServices, idiConstants]).name;

